<form [formGroup]='formGroup' class='mb-2'>
  <div class='form-group form-group--treatment'>
    <label [htmlFor]='inputId' [innerHTML]='label'></label>

    <pt-widget-action
      (clickCancel)='clickCancel.emit()'
      (clickEdit)='clickEdit.emit()'
      (clickSave)='clickSaveChange.emit()'
      [disabledCancel]='false'
      [disabledEdit]='!enabledEdit'
      [disabledSave]='false'
      [showCancel]='!isDisabled'
      [showEdit]='isDisabled'

      [showIcon]='false'
      [showLoader]='false'
      [showReload]='false'

      [showSave]='!isDisabled'
      actionStyle='TEXT'
      style='float: right'>
      >
    </pt-widget-action>


    <input (click)='clickInput.emit()'
           [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           [ngClass]="{'text-black': !isDisabled}"
           [readOnly]='true'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           class='form-control form-control-sm'
           formControlName='value'
           type='text'>
  </div>
</form>
